// removed by extract-text-webpack-plugin
module.exports = {"safetyDocItemErrorDialog":"Um1vVRinaGrjcFslBVzwZ"};


//////////////////
// WEBPACK FOOTER
// ./src/styles/componentStyle/worker/safetyDocItemErrorDialog.scss
// module id = 13231
// module chunks = 0